import { render, staticRenderFns } from "./BonusRequests.vue?vue&type=template&id=0d89bc92&scoped=true"
import script from "./BonusRequests.vue?vue&type=script&lang=js"
export * from "./BonusRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d89bc92",
  null
  
)

export default component.exports